export function isPointNotInRect(rect: DOMRect, ptX: number, ptY: number) {
  return (
    ptY < rect.top || ptY > rect.bottom || ptX < rect.left || ptX > rect.right
  );
}
